import React, { useState } from 'react';
import { resetUserPassword } from '../../utils/firebase/firebase.utils'; // Adjust the import path as necessary

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handlePasswordReset = async () => {
        const { success, error: resetError } = await resetUserPassword(email);
        if (success) {
            setMessage("Password reset email sent!");
        } else {
            setError("Failed to send password reset email. Please try again.");
            console.error("Error sending password reset email: ", resetError);
        }
    };

    return (
        <div style={{ height: '50%', width: '50%', margin: 'auto' }}>
            <h2>Forgot Password</h2>
            <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
            />
            <button onClick={handlePasswordReset}>Send Password Reset Email</button>
            {message && <p style={{ color: 'green' }}>{message}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
        </div>
    );
};

export default ForgotPassword;
